type Method = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE'
interface FormSetupProps {
  method?: Method
}

const FormSetup = ({ method = 'POST' }: FormSetupProps) => {
  const { key, value } = getAuthToken()
  const requiresMethodOverride = method !== 'POST' && method !== 'GET'

  return (
    <>
      <input type='hidden' name='utf-8' value='✓' />
      {key && value && <input type='hidden' name={key} value={value} />}
      {requiresMethodOverride && (
        <input type='hidden' name='_method' value={method} />
      )}
    </>
  )
}

export default FormSetup

function getAuthToken() {
  const key = document
    .querySelector('meta[name="csrf-param"]')
    ?.getAttribute('content')
  const value = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content')

  return { key, value }
}
